export default {
	name: 'FirstVisit',
	props: {
		img: {
			type: String,
			default: '',
		}
	},
	data() {
		return {
			visited: true,
		};
	},
	mounted() {
		this.visited = localStorage.getItem("visited") || false;

		if (!this.visited) {
			setTimeout(() => {
				this.visited = true
				localStorage.setItem("visited", true);
			}, 1500);
		}
	},
	template: `
		<div class="first-visit" v-show="!visited">
			<img :src="img" alt="" class="first-visit-image">
		</div>
	`
}
